'use client';
import getCDNURL from '@pickleballinc/ui/components/global/utils/getCDNURL';

import { Session } from '@/lib/getSessionPages';
import MatchesComponent from '@/modules/league/new-components/matches-components/MatchesComponent/MatchesComponent';
import {
  GameDayInfo,
  MatchesResult,
  PlayersOnBench,
  Round,
  SequenceButtons,
} from '@/modules/league/new-components/types';

interface MatchesContentProps {
  headerContent: GameDayInfo;
  user?: Session;
  matchesResult: MatchesResult;
  rounds: { sequences: Round[] };
  benchGroup: { ratingSessionPlayersOnBench: PlayersOnBench[] };
  allPlayersForRemove: { allRatingSessionPlayers: PlayersOnBench[] };
  sequenceStats: { sequenceStats: SequenceButtons[] };
  isAuthorized: boolean;
}

const MatchesWrapper = ({
  headerContent,
  user,
  matchesResult,
  rounds,
  benchGroup,
  allPlayersForRemove,
  sequenceStats,
  isAuthorized,
}: MatchesContentProps) => {
  const { details } = headerContent;

  return (
    <div className='md:gap-3pt-11 mx-auto h-auto w-full max-w-screen-xl gap-8 md:flex lg:w-4/5'>
      <div className='mx-auto h-auto w-full lg:max-w-full lg:gap-[24px]'>
        {details.isMatchStarted ? (
          <MatchesComponent
            headerContent={headerContent}
            isAuthorized={isAuthorized}
            userUuid={user?.pbUuid}
            matchesResult={matchesResult}
            rounds={rounds}
            benchGroup={benchGroup}
            allPlayersForRemove={allPlayersForRemove}
            sequenceStats={sequenceStats}
          />
        ) : (
          <div className='flex size-full flex-col items-center justify-center pt-4 text-leagues-300'>
            <div className='flex flex-col items-center gap-2'>
              <h2 className='text-center text-base font-semibold md:text-lg lg:text-2xl'>
                Matches will show once the game day starts.
              </h2>
              {isAuthorized && details.isLocked && !details.isFlexLeague && (
                <p className='text-center text-xs text-leagues-300 md:text-sm lg:text-base'>
                  To start the game day, toggle “Start matches” to ON.
                </p>
              )}
            </div>
            <img
              src={`${getCDNURL(`${process.env.NEXT_PUBLIC_IMAGE_CDN}/global/padel/PL-padel.svg`, 735, 400)}`}
              alt='Loading'
              className='size-auto'
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default MatchesWrapper;
